import { type ITypographyProps, Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const FlowDropdownLabel = (props: Pick<ITypographyProps, 'children' | 'ariaLabel'>) => {
  return <Typography className={styles.label} variant={'body-sm-medium'} {...props} />
}
